// tslint:disable:radix
import { ReportService } from './../../../../services/report/report.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '@constants/constants';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BreadCrumb } from '@app/constants/types';
import { SearchInputDynamicComponent } from '@app/components/search-input-dynamic/search-input-dynamic.component';
import { ProjectsService } from '@app/services/projects/projects.service';
import { NotificationsService, ObservatoryService, StorageService, UserService } from '@app/services/services.module';
import { Subject, Subscription } from 'rxjs';
import { SimpleInputComponent } from '@app/components/simple-input/simple-input.component';
import { UtilsService } from '@app/services/utils/utils.service';
import { RecognitionService } from '@app/services/recognition/recognition.service';
import { RecognitionModalComponent } from '@app/pages/admin/proyectos/reconocimiento-proyectos/recognition-modal/recognition-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { APP_URLS } from '@app/constants/app-urls';
import { ROL_TYPE } from '@app/constants/enums';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-reconocimiento-proyectos',
  templateUrl: './reconocimiento-proyectos.component.html',
  styleUrls: ['./reconocimiento-proyectos.component.scss']
})
export class ReconocimientoProyectosComponent implements OnInit, OnDestroy {
  @ViewChild('searchInput') searchInput: SearchInputDynamicComponent;
  @ViewChild('simpleInput') simpleInput: SimpleInputComponent;
  @ViewChild('recognitionModa') recognitionModa: RecognitionModalComponent;

  private subscriptions: Array<Subscription> = [];
  private recognitionPost = false;
  private selectedDivisionId: string;
  private selectedProjectString: string;
  private listOfAllProjets = [];

  public clearListClient: Subject<void> = new Subject<void>();
  public arrayOfBreadCrumbs: BreadCrumb[] = [
    {
      name: 'ADMIN_GLOBAL.INICIO',
      route: 'home',
      icons: ['fas fa-home icon_menu_bread']
    },
    {
      name: 'ADMIN_GLOBAL.DISTRIBUIDORA',
      route: 'distribuidora',
      icons: ['fas fa-cog icon_menu_bread']
    },
    {
      name: 'DIST_ADMIN.PROJECT_RECOGNITION',
      route: 'reconocimiento-proyectos',
      icons: ['fas fa-project-diagram', 'fas fa-cog SecondIcon']
    }
  ];
  public divisions = [];
  public currentView = 'DIST_ADMIN.PROJECT_RECOGNITION';
  public listOfSelectedProjects = [];
  public months = [];
  public years: string [] = [];
  public selectedYear = '';
  public selectedMonth = '';
  public enabledStatus: string = Constants.enabledStatus;
  public blockedStatus: string = Constants.blockedStatus;
  public openModal = false;
  public lockOrUnlockMessage = '';
  public modalTitle = '';
  public selectedRow: any = {};
  public userData: any ;
  public openRecognitionModal = false;
  public recognitionModalTitle = '';
  public APP_URLS = APP_URLS;
  public recognitionData: {
    service: number,
    ownStaff: number,
    externalStaff: number,
    recognitionId: number,
  } = {
    service: 0,
    ownStaff: 0,
    externalStaff: 0,
    recognitionId: 0
  };
  public orderBy = {
    client: undefined,
    projectCode: undefined,
    projectName: undefined,
    projectRecognition: undefined
  };

  constructor(
    private titleService: Title,
    private projectsService: ProjectsService,
    private storage: StorageService,
    private utilsService: UtilsService,
    private observatory: ObservatoryService,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private user_service: UserService,
    private reportService: ReportService,
    private recognitionService: RecognitionService,
    private notification: NotificationsService,
    public translate: TranslateService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    window.scrollTo(0, 0);
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.user_service.getUserData().subscribe((val) => {
      this.userData = val;
      this.initCurrentDate();
      this.initArrayOfMonths();
      this.intArrayOfYears();
      this.initData();
    });
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
  }

  closeModalOfRecognition(): void {
    this.openRecognitionModal = false;
    this.selectedRow = {};
    this.modalService.dismissAll();
  }

  generateReport(): void {
    if (this.userData.profileId === ROL_TYPE.admin) {
      this.reportService.getRecognitionReportForAdmin(this.selectedMonth, this.selectedYear);
    } else if (this.userData.profileId === ROL_TYPE.direction) {
      this.reportService.getRecognitionReportForDirection(this.selectedMonth, this.selectedYear);
    }
  }

  /**
   * Recives value from operation of recognition modal
   * @param event { ownPersonal: number, services: number,  externalPersonal: number, total: number}
   */
  acceptOperationOfrecognition(event) {
    const data = {
      ...event,
      year: parseInt(this.selectedYear),
      month: parseInt(this.selectedMonth),
      projectId: this.selectedRow.intProId
    };

    if (this.recognitionPost) {
      this.recognitionService.postRecognitionData(data)
        .subscribe(response => {
          if (response.response !== 'OK') {
            this.notification.setWarning(this.translate.instant('ERRORS.ERRORORONRECOGNITION'));
          } else {
            this.loadProjects();
          }
      });
    } else {
      data.recognitionId = this.recognitionData.recognitionId;
      this.recognitionService.putRecognitionData(data).subscribe(response => {
        if (response.response !== 'OK') {
          this.notification.setWarning(this.translate.instant('ERRORS.ERRORORONRECOGNITION'));
        } else {
          this.loadProjects();
        }
      });
    }
    this.notification.setSuccess(this.translate.instant('RECOGNITION_OK'));
    this.selectedRow = {};
    this.closeModalOfRecognition();
  }

  /**
   * Open the modal of recognition
   * @param content modal section
   */
  openModalOfRecognition(content): void {
    const sendData = {
      year: parseInt(this.selectedYear),
      month: parseInt(this.selectedMonth),
      projectId: this.selectedRow.intProId
    };
    this.recognitionService.getProjectRecognitionData(sendData).subscribe(data => {
      // If the data is equal {} the recognition not exist
      if (Object.keys(data).length > 0) {
        const { externalStaff, service, ownStaff, recognitionId } = data;
        this.recognitionPost = false;
        this.recognitionData.externalStaff = externalStaff.toFixed(2);
        this.recognitionData.service = service.toFixed(2);
        this.recognitionData.ownStaff = ownStaff.toFixed(2);
        this.recognitionData.recognitionId = recognitionId;
      } else {
        this.recognitionPost = true;
        this.recognitionData.externalStaff = 0.00;
        this.recognitionData.service = 0.00;
        this.recognitionData.ownStaff = 0.00;
      }
      this.recognitionModalTitle = `${this.selectedRow.varProSapId} ${this.selectedRow.varProDescripcion}`;
      this.openRecognitionModal = true;
      this.modalService.open(content);
    });
  }

  changeArrayOfMonths() {
    const date = new Date();
    const currentYear = date.getFullYear();
    const month = date.getMonth() + 1;
    if (parseInt(this.selectedYear) !== currentYear) {
      this.selectedMonth = '01';
    } else {
      this.selectedMonth = month > 9 ? month.toString() : '0' + month;
    }

    this.initArrayOfMonths();
    this.loadProjects();
  }

  changeArrayMonth(): void {
    this.loadProjects();
  }

  /**
   * Init the current month and year
   */
  initCurrentDate(): void {
    const date = new Date();
    this.selectedYear = date.getFullYear().toString();
    const month = date.getMonth() + 1;
    this.selectedMonth = month > 9 ? month.toString() : '0' + month;
  }

  /**
   *
   * @returns selected month with all its properties
   */
  getSelectedMonth(): { code: string, name: string, status: string } {
    return this.months.find((val) => val.code === this.selectedMonth);
  }

  /**
   *Init month array
   */
  initArrayOfMonths(): void {
    this.months = Constants.months;
    this.recognitionService.getMonthStatus({ year: parseInt(this.selectedYear)}).subscribe((data) => {
      if (data) {
        this.months.forEach((month) => {
          const value = data.find((val) => val.month === parseInt(month.code));
          month.status = value && value.isBlocked ? this.blockedStatus : this.enabledStatus;
        });
      }
    });
  }

  /**
   * Init years array
   */
  intArrayOfYears(): void {
    this.recognitionService.getRecognitionCalendar().subscribe((data) => {
      if (data) {
        data.forEach((year) => {
          this.years.push(year.toString());
        });
      }
    });
  }

  /**
   * Reset all inputs to initial data
   */
  clean(): void {
    const date = new Date();
    this.listOfSelectedProjects = JSON.parse(JSON.stringify(this.listOfAllProjets));
    this.simpleInput.clear();
    this.selectedDivisionId = '';
    this.initCurrentDate();
    this.clearDivisionFilter();
    this.clearProjectFilter();
    this.applyFilters();
  }

  /**
   * Function to apply the filters
   */
  applyFilters(): void {
    this.listOfSelectedProjects = this.listOfAllProjets;
    if (this.selectedDivisionId && this.selectedDivisionId !== '') {
      this.listOfSelectedProjects = this.listOfSelectedProjects.filter((project) => project.intDivId === this.selectedDivisionId);
    }
    if (this.selectedProjectString && this.selectedProjectString !== '') {
      const search = this.selectedProjectString.toLowerCase();
      this.listOfSelectedProjects = this.listOfSelectedProjects.filter(
        (project) => project.varProDescripcion.toLowerCase().includes(search) || project.varProSapId.toLowerCase().includes(search)
      );
    }
  }
  /**
   *
   * Returns the projecth who has the string on its name or code
   * Other filters are considered
   * @param divisionId id of selected division
   */
  filterByDivision(divisionId: string): void {
    this.selectedDivisionId = divisionId;
    this.applyFilters();
  }
  /**
   * Returns the projecth who has the string on its name or code
   * Other filters are considered
   * @param projectId string to search on projects
   */
  filterByProject(projectString: string): void {
    this.selectedProjectString = projectString;
    this.applyFilters();
  }

  clearDivisionFilter(): void {
    this.selectedDivisionId = undefined;
    this.applyFilters();
  }
  clearProjectFilter(): void {
    this.simpleInput.clear();
    this.selectedProjectString = undefined;
    this.applyFilters();
  }

  openBlockModal(content): void {
    const auxMonthStatus = this.getSelectedMonth().status;
    this.lockOrUnlockMessage =  auxMonthStatus === this.blockedStatus ?  'BLOQ.UNBLOQMESSAGE' : 'BLOQ.BLOQMESSAGE';
    this.modalTitle =  auxMonthStatus === this.blockedStatus ? 'TITLE.PROJECT_MODAL_UNBLOQ' : 'TITLE.PROJECT_MODAL_BLOQ';
    this.openModal = true;
    this.modalService.open(content);
  }

  /**
   * Close modal of block month
   */
  closeModal(): void {
    this.openModal = false;
    this.modalService.dismissAll();
  }


  /**
   * Block or unblock one month of a year
   */
  blockOrUnblock(): void {
    const findedIndex = this.months.findIndex((val) => val.code === this.selectedMonth);
    const auxMonth = this.getSelectedMonth();
    const data = {
      year: parseInt(this.selectedYear),
      month: parseInt(this.months[findedIndex].code)
    };
    if (auxMonth.status === this.blockedStatus) {
      this.recognitionService.unloockMonth(data).subscribe(actualData => {
        if (actualData && actualData.response === 'OK') {
          this.months[findedIndex].status = this.enabledStatus;
        } else {
          this.notification.setWarning(this.translate.instant('ERRORS.ERRORONUNBLOCKMONTH'));
        }
      });
    } else {
      this.recognitionService.loockMonth(data).subscribe(actualData => {
        if (actualData && actualData.response === 'OK') {
          this.months[findedIndex].status = this.blockedStatus;
        } else {
          this.notification.setWarning(this.translate.instant('ERRORS.ERRORONBLOCKMONTH'));
        }
      });
    }
  }

  /**
   * Block or unblock the month and close modal
   */
  acceptOperation(): void {
    this.blockOrUnblock();
    this.closeModal();
  }

  /**
   * Load all needed data
   */
  initData(): void {
    this.divisions = this.storage.get('divisions');
    if (!this.divisions) {
      this.subscriptions.push(
        this.projectsService.getDivisions().subscribe((data: any[]) => {
          if (Array.isArray(data)) {
            this.divisions = data;
            this.storage.set('divitions', this.divisions);
          }
        }),
      );
    }
    this.loadProjects();
  }

  /**
   * Function to load the projects
   */
  loadProjects(): void {
    this.subscriptions.push(
      this.recognitionService.getRecognitionProject({
        month: this.selectedMonth,
        year: this.selectedYear
      }).subscribe((data: any[]) => {
        if (Array.isArray(data)) {
          this.listOfAllProjets = data;
          this.listOfSelectedProjects = JSON.parse(JSON.stringify(this.listOfAllProjets));
          this.applyFilters();
          this.orderProjectsByActivedOrder();
        }
      })
    );
  }

  /**
   * Set the selectedrow as the item that recives from table
   * @param row slected row on table
   */
  selectRow(row): void  {
    if (this.selectedRow && this.selectedRow.varProSapId === row.varProSapId) {
      this.selectedRow = {};
    } else {
      this.selectedRow = row;
    }
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

  routeTo(route): void {
    this.observatory.setData('route', route);
  }

  /* Orders to list */

  /**
   * Function to reset all icons order
   */
  resetOrders(): void {
    this.orderBy.client = undefined;
    this.orderBy.projectCode = undefined;
    this.orderBy.projectName = undefined;
    this.orderBy.projectRecognition = undefined;
  }

  /**
   * Function to order the list of selected projects by the actived order
   *
   * If the order is active (true or false), we change it to the opposite
   * so thath the orderProjectsBy function orders by what we want
   */
  orderProjectsByActivedOrder(): void {
    if (this.orderBy.client !== undefined) {
      this.orderBy.client = !this.orderBy.client;
      this.orderProjectsBy('client');
    } else if (this.orderBy.projectName !== undefined) {
      this.orderBy.projectName = !this.orderBy.projectName;
      this.orderProjectsBy('projectName');
    } else if (this.orderBy.projectCode !== undefined) {
      this.orderBy.projectCode = !this.orderBy.projectCode;
      this.orderProjectsBy('projectCode');
    } else if (this.orderBy.projectRecognition !== undefined) {
      this.orderBy.projectRecognition = !this.orderBy.projectRecognition;
      this.orderProjectsByRecognition();
    } else {
      this.orderProjectsBy('projectCode');
    }
  }
  /**
   * Function to order the list of selected projects
   * @param type The type of the order:
   * - client : order by clientName
   * - projectName : order by projectName
   * - projectDescription : order by varProDescripcion
   */
  orderProjectsBy(type: string): void {
    let propertyOrder = 'varProSapId';
    switch (type) {
      case 'client': propertyOrder = 'clientName'; break;
      case 'projectName': propertyOrder = 'varProDescripcion'; break;
      case 'projectCode': propertyOrder = 'varProSapId'; break;
      default: propertyOrder = 'varProSapId'; break;
    }
    if (this.orderBy[type] === undefined || this.orderBy[type] === false) {
      this.resetOrders();
      this.orderBy[type] = true;
      this.listOfSelectedProjects =
        this.utilsService.orderByAlphabetically(this.listOfSelectedProjects, propertyOrder);
    } else {
      this.resetOrders();
      this.orderBy[type] = false;
      this.listOfSelectedProjects =
        this.utilsService.orderByAlphabetically(this.listOfSelectedProjects, propertyOrder, 'DESC');
    }
  }
  orderProjectsByRecognition(): void {
    if (this.orderBy.projectRecognition === undefined || this.orderBy.projectRecognition === false) {
      this.resetOrders();
      this.orderBy.projectRecognition = true;
      this.listOfSelectedProjects =
        this.utilsService.orderByBoolean(this.listOfSelectedProjects, 'hasRecognition');
    } else {
      this.resetOrders();
      this.orderBy.projectRecognition = false;
      this.listOfSelectedProjects =
        this.utilsService.orderByBoolean(this.listOfSelectedProjects, 'hasRecognition', 'DESC');
    }
  }
  /* . Orders to list */

  isEmptyListOfSelectedProjects(): boolean {
    return !(this.listOfSelectedProjects && this.listOfSelectedProjects.length > 0);
  }
}
